<div class="flex flex-col max-w-240 md:min-w-200 max-h-screen -m-6">

    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">Upload Images</div>
        <button mat-icon-button [tabIndex]="-1" (click)="onClose()">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <div class="w-full md:mb-0 pb-2">
            <span class="flex">Type</span>
            <mat-radio-group class="flex" [color]="'primary'" [(ngModel)]="uploadType" (change)="onTypeChange($event)">
                <mat-radio-button value="Upload">Upload Image</mat-radio-button>
                <mat-radio-button value="Snap" class="pl-2">Take A Snapshot</mat-radio-button>
                <mat-radio-button value="ReportImage" class="pl-2" *ngIf="isReportDoc">Report Image</mat-radio-button>
            </mat-radio-group>
        </div>

        <mat-form-field *ngIf="uploadType === 'Upload'">
            <mat-toolbar>
                <input matInput [value]="
                    selectedFileNames.length
                      ? selectedFileNames.join(', ')
                      : 'Select Images'
                  " />
                <button mat-flat-button color="primary" [disabled]="!selectedFiles" (click)="uploadFiles()">
                    Upload
                </button>
            </mat-toolbar>

            <input type="file" id="fileInput" name="fileInput" accept="image/*" (change)="selectFiles($event)"
                multiple />
        </mat-form-field>

        <div *ngIf="uploadType === 'Snap'" class="pb-2 pt-2">
            <div class="w-full md:mb-0 pb-2">
                <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" class="w-full"></webcam>
            </div>
            <button mat-flat-button color="primary" (click)="triggerSnapshot()">Take A Snapshot</button>
            <button mat-flat-button class="ml-2" color="primary" *ngIf="selectedFiles.length > 0"
                (click)="uploadFiles()">
                Upload
            </button>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <img *ngFor="let preview of previews" [src]="preview" class="preview" />
        </div>

        <mat-form-field *ngIf="uploadType === 'ReportImage'">
            <mat-toolbar>
                <input matInput [value]="
                    selectedFileNames.length
                      ? selectedFileNames.join(', ')
                      : 'Select Images'
                  " />
                <button mat-flat-button color="primary" [disabled]="!selectedFiles" (click)="uploadFilesReport()">
                    Upload
                </button>
            </mat-toolbar>

            <input type="file" id="fileInput" name="fileInput" accept="image/*" (change)="selectFiles($event)"
                multiple />
        </mat-form-field>



        <!-- <button class="btn btn-success" [disabled]="!selectedFiles" (click)="uploadFiles()">
        Upload
    </button> -->


        <!-- <div>

    <div>
      <ngx-webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></ngx-webcam>
    </div>


    <div cdkDropList (cdkDropListDropped)="drop($event)">
      <div *ngFor="let file of selectedFiles" cdkDrag>
        {{ file.name }}
      </div>
    </div>


    <button (click)="uploadFiles()">Upload Files</button>
  </div> -->
    </div>